import React from 'react'
import Webcam from 'react-webcam'

import useTranslations from '../../../hooks/useTranslations'
import ANTDButton from '../../../shared/antd/ANTDButton'
import ANTDModal from '../../../shared/antd/ANTDModal'
import { flipIcon } from '../../../utils/icons'

const TakePhoto = ({
  takePhoto,
  isDesktop,
  facingMode,
  videoElement,
  videoConstraints,
  handleError,
  handleCapture,
  handleTakePhoto,
  handleSwitchCam,
}) => {
  const { t } = useTranslations()

  return (
    <ANTDModal
      width="800px"
      footer={
        takePhoto.valid
          ? [
              <ANTDButton
                key="back"
                className="mb-10 mr-15"
                onClick={handleTakePhoto}
              >
                {t('msg_Cancel')}
              </ANTDButton>,
            ]
          : [
              !isDesktop && (
                <ANTDButton
                  className="view-flip"
                  key="back"
                  onClick={() => handleSwitchCam()}
                >
                  <img src={flipIcon} width="25px" height="20px" alt="flip" />
                </ANTDButton>
              ),
              <ANTDButton
                key="cancel"
                className="mb-10 mr-15"
                onClick={handleTakePhoto}
              >
                {t('msg_Cancel')}
              </ANTDButton>,
              <ANTDButton
                key="ok"
                className="mb-10 mr-15"
                onClick={handleCapture}
              >
                {t('msg_OK')}
              </ANTDButton>,
            ]
      }
      className="take-image-modal"
      closable={false}
      open={takePhoto.flag}
    >
      {takePhoto.valid ? (
        <div className="text-center scanner-not-connect">
          <h2> {takePhoto.valid}</h2>
        </div>
      ) : (
        <Webcam
          screenshotFormat="image/png"
          audio={false}
          videoConstraints={{
            width: { ideal: 1280 },
            height: { ideal: 720 },
            facingMode,
          }}
          ref={videoElement}
          style={{ width: '100%', height: '600px' }}
          onUserMediaError={handleError}
          playsInline
        />
      )}
    </ANTDModal>
  )
}

export default TakePhoto
